var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectoryChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6186 12.5528L22.3422 12H21.7241H5.03867C2.81425 12 1 13.7915 1 16.0211V43.3582C1 45.5824 2.81619 47.3793 5.0243 47.3793H42.9757C45.1989 47.3793 47 45.5766 47 43.3523V22.096C47 19.8672 45.1865 18.069 42.9566 18.069H25.3767L22.6186 12.5528Z",
    fill: "#42C0B9",
    stroke: "#414955",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4244 23.5358L19.7011 18.4076H4.72701C3.22092 18.4076 2 19.5482 2 20.9604V44.06C2 45.4698 3.22507 46.6127 4.71411 46.6127H43.2859C44.7849 46.6127 46 45.4683 46 44.0549V26.0936C46 24.681 44.7785 23.5358 43.2688 23.5358H22.4244Z",
    fill: "#7FD5D0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_109_222",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1067 36L42.1047 36.259L41.998 43.2582L25 42.9992L25.1067 36Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.1067 36L42.1047 36.259L41.998 43.2582L25 42.9992L25.1067 36Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0133 42.2583L25.0152 41.9993L24.9848 43.9991L41.9828 44.2581L42.0133 42.2583Z",
    fill: "white",
    fillOpacity: 0.4,
    mask: "url(#path-3-inside-1_109_222)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectoryChecklist);
export default __webpack_public_path__ + "static/media/directory_checklist.fe2667d10ab834808a3a599e446ba864.svg";
export { ForwardRef as ReactComponent };